import page from './segmentWrapper.js'
import global from './events/global.js'

let segmentLoaded = false
async function loadSegment(segmentToken) {
  const analytics = (window.analytics = window.analytics || [])
  if (!analytics.initialize && !segmentLoaded) {
    segmentLoaded = true
    if (analytics.invoked) {
      window.console &&
        console.error &&
        console.error('Segment snippet included twice.')
    } else {
      analytics.invoked = true
      analytics.methods = [
        'trackSubmit',
        'trackClick',
        'trackLink',
        'trackForm',
        'pageview',
        'identify',
        'reset',
        'group',
        'track',
        'ready',
        'alias',
        'debug',
        'page',
        'once',
        'off',
        'on',
        'addSourceMiddleware',
        'addIntegrationMiddleware',
        'setAnonymousId',
        'addDestinationMiddleware'
      ]
      analytics.factory = function (method) {
        return function () {
          const args = Array.prototype.slice.call(arguments)
          args.unshift(method)
          analytics.push(args)
          return analytics
        }
      }
      for (let i = 0; i < analytics.methods.length; i++) {
        const key = analytics.methods[i]
        analytics[key] = analytics.factory(key)
      }
      analytics.load = function (key, options) {
        let script = document.createElement('script')
        script.type = 'text/javascript'
        script.async = true
        script.src =
          'https://cdn.segment.com/analytics.js/v1/' + key + '/analytics.min.js'
        script.id = 'segment-script'
        let first = document.getElementsByTagName('script')[0]
        if (first && first.parentNode) {
          first.parentNode.insertBefore(script, first)
        } else {
          document.head.appendChild(script)
        }
        analytics._loadOptions = options
      }
      analytics.SNIPPET_VERSION = '4.15.2'
      analytics.load(segmentToken)
    }
  }
}

async function loadSegmentScript(segmentToken) {
  await loadSegment(segmentToken)
}

export default {
  page, // Make Page Segment Calls available to Vue Components
  global,
  loadSegment,
  loadSegmentScript
}
